import React from 'react';
import Portal from 'lib/components/portal.jsx';
import { mergeClasses } from 'lib/helpers/class.js';

const ManageControlsContext = React.createContext();
ManageControlsContext.displayName = 'ManageControlsContext';

export function useManageControls() {
    return React.useContext(ManageControlsContext) ?? {};
}

function Provider(props) {
    const { hideControls = false, children } = props;

    const barSlotId = React.useId();
    const buttonSlotId = React.useId();

    return (
        <ManageControlsContext.Provider value={{ hideControls, barSlotId, buttonSlotId }}>
            {children}
        </ManageControlsContext.Provider>
    );
}

export default function ManageControls(props) {
    const { children, className, ...rest } = props;
    const { hideControls, barSlotId, buttonSlotId } = useManageControls();
    if (hideControls || (!barSlotId && !buttonSlotId)) return null;
    return (
        <div
            className={mergeClasses('fixed top-[64px] w-full pl-3 pr-4 isolate z-10', className)}
            style={{
                pointerEvents: 'none'
            }}
            {...rest}
        >
            <div className="flex min-h-[2rem] flex-1 flex-wrap gap-2 items-center">
                {children}
                <div className="flex flex-grow pl-[2px]" id={barSlotId} />
                <div
                    className="ml-auto flex items-center gap-2 md:mt-0 rounded-lg backdrop-blur p-[6px]"
                    style={{
                        pointerEvents: 'auto'
                    }}
                    id={buttonSlotId}
                />
            </div>
        </div>
    );
}

function BarSlot(props) {
    const { className } = props;
    const { hideControls, barSlotId } = useManageControls();
    if (hideControls || !barSlotId) return null;
    return (
        <Portal root={barSlotId} className={className}>
            {props.children}
        </Portal>
    );
}

function ButtonSlot(props) {
    const { hideControls, buttonSlotId } = useManageControls();
    if (hideControls || !buttonSlotId) return null;
    return <Portal root={buttonSlotId}>{props.children}</Portal>;
}

ManageControls.BarSlot = BarSlot;
ManageControls.ButtonSlot = ButtonSlot;
ManageControls.Provider = Provider;
